import { View, Text, StyleSheet } from "react-native";
import { useAppConfig } from "../../../AppConfigProvider";

function UserInitial({ initial, type, style = {}, textStyle = {} }) {
  const { primaryColor } = useAppConfig();

  const isMenu = type === "menu";

  const containerStyle = [
    styles.container,
    isMenu
      ? {
          background: "linear-gradient(95deg, #3e68fe -26%, #913daf 129.04%)",
          backgroundColor: "#d9d9d9",
          height: 36,
          width: 36,
          borderRadius: 24,
        }
      : {
          backgroundColor: primaryColor,
        },
    style,
  ];

  const combinedTextStyle = [
    styles.text,
    isMenu && {
      color: "#fff",
      fontSize: 20,
      lineHeight: 24,
    },
    textStyle,
  ];

  return (
    <View style={containerStyle} role="img" aria-label={initial ? `User initial: ${initial}` : "User initial"}>
      <Text style={combinedTextStyle}>{initial}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 24,
    width: 24,
    borderRadius: 12,
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    color: "#fff",
    fontSize: 14,
    fontWeight: "bold",
  },
});

export default UserInitial;
